export default __webpack_public_path__ + "static/media/mission.f32ed620.png";